import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query'

import { TokenInterface, setToken } from '@store/actionSlices/token'

const renewUserAccessToken = async (
  token: TokenInterface,
  api: any,
  extraOptions: any
): Promise<boolean> => {
  let status = true

  const baseUrl = process.env.REACT_APP_API_URL
  const client_id = process.env.REACT_APP_CLIENT_ID
  const client_secret = process.env.REACT_APP_CLIENT_SECRET

  const {
    refresh_token: { token: refreshToken },
    email: userEmail,
  } = token

  const headers = new Headers()
  headers.set('user', userEmail)

  const baseQuery = fetchBaseQuery({ baseUrl })

  const response = await baseQuery(
    {
      url: '/v1/user/refresh-token',
      method: 'post',
      body: {
        client_id,
        client_secret,
        refresh_token: refreshToken,
      },
      headers,
    },
    api,
    extraOptions
  )

  if (response.data) {
    const {
      data: {
        user: { access_token, refresh_token, email, _id },
      },
    } = response.data as {
      data: { user: TokenInterface }
    }
    api.dispatch(setToken({ access_token, refresh_token, email, _id }))
  } else {
    console.error('Failed to renew the user token.', response)
    status = false
  }

  return status
}

export default renewUserAccessToken
